import React from 'react';
import {
  Box,
  Card,
  Chip,
  Stack,
  Typography,
} from '@mui/material';

import EmptyState from '../feedback/EmptyState';

const InsightCard = ({
  title,
  description,
  badge,
  actions,
  isEmpty,
  emptyProps,
  children,
  sx,
}) => (
  <Card
    sx={{
      p: 3.5,
      borderRadius: '12px !important',
      height: '100%',
      background: '#FFFFFF',
      border: '1px solid rgba(122, 59, 193, 0.06)',
      boxShadow: '0 6px 18px rgba(15, 23, 42, 0.06)',
      ...sx,
    }}
  >
    <Stack spacing={2} sx={{ height: '100%' }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
        <Box>
          {title && (
            <Typography variant="h6" fontWeight={600}>
              {title}
            </Typography>
          )}
          {description && (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          )}
        </Box>
        <Stack direction="row" spacing={1} alignItems="center">
          {badge && (
            <Chip
              icon={badge.icon}
              label={badge.label}
              color={badge.color}
              variant={badge.variant || 'filled'}
              size={badge.size || 'medium'}
              sx={{ fontWeight: 600, textTransform: badge.textTransform || 'none' }}
            />
          )}
          {actions}
        </Stack>
      </Stack>

      <Box sx={{ flexGrow: 1, minHeight: 0 }}>
        {isEmpty ? <EmptyState {...emptyProps} /> : children}
      </Box>
    </Stack>
  </Card>
);

export default InsightCard;
